import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectorRef,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
  QualificationTrainingProvider,
  QualificationTrainingProviderClass,
} from '@wilson/interfaces';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'wilson-classes-renderer',
  template: `
    <nz-form-item>
      <nz-form-control>
        @if (isEditable) {
          <nz-select
            [nzDisabled]="
              !selectedProvider ||
              !providerClasses ||
              providerClasses?.length === 0 ||
              providerClasses?.length === 1
            "
            nzShowSearch
            [nzDropdownStyle]="{ 'min-width': '400px' }"
            nzAllowClear
            [nzPlaceHolder]="'general.search' | translate"
            [(ngModel)]="selectedClass"
            (ngModelChange)="onChange($event)"
            [nzPlacement]="'bottomLeft'"
          >
            @for (class of providerClasses; track class.id) {
              <nz-option [nzLabel]="class.name" [nzValue]="class"></nz-option>
            }
          </nz-select>
        } @else {
          <div
            class="text-display"
            nz-tooltip
            [nzTooltipTitle]="$safeNavigationMigration(selectedClass?.name)"
          >
            {{ selectedClass?.name }}
          </div>
        }
      </nz-form-control>
    </nz-form-item>
  `,
  styles: [
    `
      .text-display {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
        display: block;
      }
    `,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    NzSelectModule,
    NzDividerModule,
    NzIconModule,
    NzInputModule,
    NzFormModule,
    TranslatePipe,
    NzTooltipModule,
  ],
})
export class ClassesRendererComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);

  @Input() set selectedProvider(value: QualificationTrainingProvider | null) {
    this._selectedProvider = value;
    this.updateSelectedClass();
  }
  get selectedProvider(): QualificationTrainingProvider | null {
    return this._selectedProvider;
  }
  @Input() set providerClasses(value: QualificationTrainingProviderClass[]) {
    this._providerClasses = value;
    this.updateSelectedClass();
  }
  get providerClasses(): QualificationTrainingProviderClass[] {
    return this._providerClasses;
  }
  @Input() set currentSelectedClass(
    value: QualificationTrainingProviderClass | null,
  ) {
    this._currentSelectedClass = value;
    this.updateSelectedClass();
  }
  get currentSelectedClass(): QualificationTrainingProviderClass | null {
    return this._currentSelectedClass;
  }
  @Input() index!: number;
  @Input() isEditable = false;
  @Output() classChange =
    new EventEmitter<QualificationTrainingProviderClass>();

  selectedClass: QualificationTrainingProviderClass | null = null;
  private _selectedProvider: QualificationTrainingProvider | null = null;
  private _providerClasses: QualificationTrainingProviderClass[] = [];
  private _currentSelectedClass: QualificationTrainingProviderClass | null =
    null;

  ngOnInit(): void {
    this.updateSelectedClass();
  }

  private async updateSelectedClass(): Promise<void> {
    if (this.currentSelectedClass) {
      this.selectedClass = this.currentSelectedClass;
    } else if (this.providerClasses?.length === 1) {
      this.selectedClass = this.providerClasses[0];
      await this.onChange(this.providerClasses[0]);
    } else {
      this.selectedClass = null;
    }
    this.cdr.detectChanges();
  }

  async onChange(
    selectedClass: QualificationTrainingProviderClass,
  ): Promise<void> {
    this.selectedClass = selectedClass;
    this.classChange.emit(selectedClass);
    this.cdr.detectChanges();
  }
}
